import { cn } from "../lib/utils";
import React from "react";
export function SettingsList({ children, className }) {
    return (React.createElement("div", { className: cn("flex flex-col overflow-hidden rounded-2xl border border-border divide-y divide-border", className) }, children));
}
function SettingsListRow({ title, description, action, className, }) {
    return (React.createElement("div", { className: cn("flex items-center justify-between gap-4 px-4 py-4", className) },
        React.createElement("div", { className: "flex min-w-0 flex-col gap-0.5" },
            React.createElement("span", { className: "heading-sm text-foreground" }, title),
            description && (React.createElement("span", { className: "copy-sm text-muted-foreground" }, description))),
        action && React.createElement("div", { className: "shrink-0" }, action)));
}
SettingsList.Row = SettingsListRow;
//# sourceMappingURL=SettingsList.js.map